var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14375 4.14697C2.14375 2.86447 3.18625 1.82197 4.46875 1.82197H7.46875V0.396973H4.46875C2.39875 0.396973 0.71875 2.07697 0.71875 4.14697C0.71875 6.21697 2.39875 7.89697 4.46875 7.89697H7.46875V6.47197H4.46875C3.18625 6.47197 2.14375 5.42947 2.14375 4.14697ZM5.21875 4.89697H11.2188V3.39697H5.21875V4.89697ZM11.9688 0.396973H8.96875V1.82197H11.9688C13.2513 1.82197 14.2938 2.86447 14.2938 4.14697C14.2938 5.42947 13.2513 6.47197 11.9688 6.47197H8.96875V7.89697H11.9688C14.0387 7.89697 15.7188 6.21697 15.7188 4.14697C15.7188 2.07697 14.0387 0.396973 11.9688 0.396973Z",
    fill: "#8891A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3061065948209154022a8d6a4c834c1a.svg";
export { ForwardRef as ReactComponent };